




































import { Vue, Component, Prop } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import eventCategoryModel from "@/models/event/eventCategoryModel";

@Component
export default class CategoryTable extends Vue {
  @Prop(Array) private items!: Array<eventCategoryModel>;
  @Prop(Boolean) private loading!: boolean;
  @Prop(Array) private headers!: Array<DataTableHeader<eventCategoryModel>>;
}
